























































































































































import { Component, Vue } from 'vue-property-decorator';
import { search_agency_sales_reports } from '@/api/salesreport';
import { list_agent_summaries, listAgentSummaries } from '@/api/agent';
import { AgentTypeEnum } from '@/api/types';
import {
  toMonthRange,
  monthStringToIDate,
  formatApiError,
  formatDate,
} from '@/utils/index';
import { agentSummaryById } from '@/utils/agent';
import { AppModule } from '@/store/modules/app';
import { SalesReportModule } from '@/store/modules/salesreport';

type ItemType = {
  text: string;
  value: string;
};

@Component({
  name: 'SalesReportListSearch',
})
export default class SalesReportListSearch extends Vue {
  public static readonly salesReportSearchEvent = 'sales-report-search';
  private openPanels = [0];
  private targetMonthMenu = false;
  private targetMonth: string | null = null;
  private targetMonthRules: ((v: string) => boolean | string)[] = [];
  private fromMenu = false;
  private fromMonth: string | null = null;
  private fromMonthRules: ((v: string) => boolean | string)[] = [];
  private toMenu = false;
  private toMonth: string | null = null;
  private toMonthRules: ((v: string) => boolean | string)[] = [];
  private agents: Map<string, list_agent_summaries.AgentSummary> = new Map();
  private agentIds: string[] = [];
  private agentItems: ItemType[] = [];
  private agentRules: ((v: ItemType[]) => boolean | string)[] = [];

  get canSearch() {
    return (
      // this.fromMonth &&
      // this.toMonth &&
      this.targetMonth && this.agentIds && this.agentIds.length > 0
    );
  }

  created() {
    this.loadSalesReportListSearchForm();
    this.loadRules();
  }

  mounted() {
    this.fetchData();
    if (this.canSearch) {
      this.search();
    }
  }

  search() {
    const req = {
      targetMonth: monthStringToIDate(this.targetMonth)!,
      // targetMonth: toMonthRange(
      //   monthStringToIDate(this.fromMonth)!,
      //   monthStringToIDate(this.toMonth)!,
      //   true
      // ),
      agentIds: this.agentIds,
    } as search_agency_sales_reports.Request;
    this.$emit(SalesReportListSearch.salesReportSearchEvent, req);
    SalesReportModule.SaveSalesReportListSearchForm({
      // fromMonth: this.fromMonth,
      // toMonth: this.toMonth,
      targetMonth: this.targetMonth,
      agentIds: this.agentIds,
    });
  }

  reset() {
    SalesReportModule.ClearSalesReportListSearchForm();
    this.loadSalesReportListSearchForm();
  }

  private loadRules() {
    this.targetMonthRules = [
      (v: string) =>
        !!v ||
        (this.$t('{msg} is required', {
          msg: this.$t('Target month'),
        }) as string),
    ];
    this.fromMonthRules = [
      (v: string) =>
        !!v ||
        (this.$t('{msg} is required', {
          msg: this.$t('From month'),
        }) as string),
    ];
    this.toMonthRules = [
      (v: string) =>
        !!v ||
        (this.$t('{msg} is required', {
          msg: this.$t('To month'),
        }) as string),
    ];
    this.agentRules = [
      (v: ItemType[]) =>
        (!!v && v.length > 0) ||
        (this.$t('{msg} is required', {
          msg: this.$t('Agent'),
        }) as string),
    ];
  }

  private loadSalesReportListSearchForm() {
    // this.fromMonth = SalesReportModule.salesReportListSearchForm.fromMonth;
    // this.toMonth = SalesReportModule.salesReportListSearchForm.toMonth;
    this.targetMonth = SalesReportModule.salesReportListSearchForm.targetMonth;
    this.agentIds = SalesReportModule.salesReportListSearchForm.agentIds;
  }

  private async fetchData() {
    AppModule.StartProgress();
    try {
      const listAgentsRes = await listAgentSummaries({
        agentTypes: Object.values(AgentTypeEnum).filter(
          t => (t as AgentTypeEnum) === AgentTypeEnum.DOMESTIC_AGENCY
        ),
      } as list_agent_summaries.Request);
      this.agents = agentSummaryById(listAgentsRes.agentSummaries);
      this.loadAgentItems();

      AppModule.StopProgress();
    } catch (err) {
      AppModule.StopProgress();
      this.$toast.error(
        this.$t('Failed to {do} due to {err}', {
          do: (this.$t('Fetch {msg}', {
            msg: this.$t('Agent'),
          }) as string).toLowerCase(),
          err: formatApiError(this.$i18n, err),
        }) as string,
        {
          icon: 'mdi-alert',
        }
      );
    }
  }

  private loadAgentItems() {
    this.agentItems = [];
    this.agents.forEach(a => {
      this.agentItems.push({
        text: a.name,
        value: a.id,
      });
    });
  }

  private fromAllowedDates(val: string | null) {
    return !val || !this.toMonth || val <= this.toMonth;
  }

  private toAllowedDates(val: string | null) {
    return !val || !this.fromMonth || val >= this.fromMonth;
  }
}
